import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

// Drawer (Wave 47p) — explicit positioning via studio CSS classes so
// it renders predictably on every build. Earlier Tailwind-only
// implementation depended on `max-w-xl`/`w-screen`/`data-closed:`
// arbitrary values rendering correctly through PostCSS, and at
// least one of those was failing — operator screenshot showed the
// drawer occupying half the screen with content squeezed to one
// edge. Studio classes give us a consistent right-anchored panel
// at 460px wide with proper padding.

export function Drawer({ open, onClose, title, children, footer }) {
  return (
    <Dialog open={open} onClose={onClose} className="studio-drawer-root">
      <DialogBackdrop className="studio-drawer-backdrop" />
      <div className="studio-drawer-positioner">
        <DialogPanel className="studio-drawer-panel">
          <div className="studio-drawer-head">
            <DialogTitle className="studio-drawer-title">{title}</DialogTitle>
            <button
              type="button"
              className="studio-drawer-close"
              onClick={() => onClose(false)}
              aria-label="Close drawer"
            >
              <XMarkIcon width={16} height={16} aria-hidden="true" />
            </button>
          </div>
          <div className="studio-drawer-body">{children}</div>
          {footer ? <div className="studio-drawer-footer">{footer}</div> : null}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
